import React from 'react';
import NormalPieChart from '../components/charts/pies/pieWithPadding';
import { useEleccion } from '../contexts/eleccionContext';
import { useNomenclator } from '../contexts/nomenclatorContext';
import { Leyenda } from './Graficas/Reparto';
import styled from 'styled-components/macro';
import useIni from '../hooks/useIni';
import transformDataForPieWithPadding from '../components/charts/pies/transformDataForPieWithPadding';
import addPaddingToPieData from '../components/charts/pies/addPaddingToPieData';
import { withRouter } from 'react-router-dom';
import { themes } from '../styles/themes';
import { useIsMobile } from '../hooks/useMediaQuery';
import { responsive } from '../resources/constantes.json';

class PieErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      didError: false,
    };
  }

  componentDidCatch() {
    this.setState({ didError: true });
  }

  render() {
    if (this.state.didError) {
      return (
        <ErrorContainer>
          <p>Ha ocurrido un error al cargar el gráfico.</p>
          <p>Recargue la página.</p>
        </ErrorContainer>
      );
    }
    return this.props.children;
  }
}

const ErrorContainer = styled.div`
  width: 100%;
  height: 100%;
  min-height: 30vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 3rem;
  box-sizing: border-box;
  & > p {
    font-size: 2rem;
    text-align: center;
  }
`;

const PieResultados = ({ location }) => {
  const nomenclator = useNomenclator();
  const elecOptions = useEleccion();
  const { idEleccion } = elecOptions;
  const colorEleccion = nomenclator?.nomAmbitos?.[idEleccion]?.c;
  const { showCurules } = useIni();

  const datos = transformDataForPieWithPadding(
    elecOptions?.selectedCamara?.partotabla,
    nomenclator,
    showCurules
  );
  const dataWithPadding = addPaddingToPieData(datos, 0.2);
  const silentMouseEvents =
    dataWithPadding.length === 1 && dataWithPadding[0].name === 'empty';
  const isMobile = useIsMobile();
  return (
    <PieErrorBoundary>
      <Container colorEleccion={colorEleccion}>
        <SubContainer>
          <NormalPieChart
            data={dataWithPadding}
            name={'resultados'}
            minRadius={55}
            silentMouseEvents={silentMouseEvents}
            key={location.pathname}
          />
        </SubContainer>
        <div
          style={{
            flex: '1 1 0%',
          }}
        >
          <Leyenda
            camaraSeleccionada={elecOptions.selectedCamara}
            stylesLeyendaContainer={{
              padding: isMobile ? '' : '0px 20px 20px',
            }}
            styleLeyendaPartido={{ margin: 0 }}
          />
        </div>
      </Container>
    </PieErrorBoundary>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background-color: ${themes.inicio.backgroundColor};
  border-radius: 25px;
  color: #174292;
  @media (max-width: ${responsive.mobile}px) {
    height: auto;
    padding: 20px 0;
    border-radius: 20px;
  }
`;

const SubContainer = styled.div`
  position: relative;
  display: flex;
  aspect-ratio: 1/1;
  justify-content: center;
  @media (max-width: ${responsive.tablet}px) {
    width: 70%;
    align-self: center;
  }
  @media (max-width: ${responsive.mobile}px) {
    width: 50%;
    align-self: center;
  }
  width: 100%;
  height: 100%;
  max-width: 550px;
  max-height: 550px;
  margin: 0 auto;
`;

export default withRouter(PieResultados);
